import React from 'react'
import { StyledSkeleton } from './SetSkeleton.styles'

const SetSkeleton = () => <StyledSkeleton active />

export default SetSkeleton
